module.exports = __webpack_public_path__ + "static/media/Barmag 5b.ed4bbae2.jpg";